<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      hide-footer
      @hide="tryCloseActivityModal"
  >
    <validation-observer #default="{handleSubmit}">
      <b-form @submit.prevent="handleSubmit(submitValidatedActivityLocal)">
        <form-activity :activity="activityLocal"/>
        <button ref="submitActivityFormRef"
                class="d-none"></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'

import FormActivity from '@/components/form/Activity'

export default {
  components: {
    ValidationObserver,
    FormActivity
  },
  props: {
    activity: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const activityLocal = ref(props.activity)
    const submitActivityFormRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(activityLocal, (val) => {
      emit('update:activity', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseActivityModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitActivityFormRef.value.click()
      }
    }

    const submitValidatedActivityLocal = () => {
      emit('submitValidatedActivity')
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data
      isOpenLocal,
      activityLocal,
      submitActivityFormRef,

      // Computed

      // Methods
      tryCloseActivityModal,
      submitValidatedActivityLocal
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    activity: function (val) {
      this.activityLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>